<!--no sufficient fund-->
<div class="overlay-fungame" *ngIf="funGameNotAvailable">
  <div id="dummy-overlay" (click)="PLSTPopUpClick(false, 3)"></div>
  <div
    style="position: absolute; width: 100%"
    [ngStyle]="{ height: contentHeight + 'px' }"
  >
    <div id="dummy-overlay" (click)="PLSTPopUpClick(false, 3)"></div>
    <table class="popup-container">
      <tr>
        <td>
          <div class="popup-img-insufficientfund">
            <img
              class="img-bg"
              src="assets/images/common/insufficient_funds2.webp"
            />
            <div class="template-block">
              <div
                class="popup-pos-layout popup-header-insufficientfund playforfun-pos_1 lang-specific-font-name"
              >
                <span class="popup-language-txt">{{
                  'LANG00029' | translate
                }}</span>
              </div>
              <div
                class="popup-pos-layout popup-header-insufficientfund playforfun-pos lang-specific-font-name"
              >
                <span class="popup-language-txt">{{
                  'LANG01068' | translate
                }}</span>
              </div>
              <div
                class="popup-pos-layout popup-header-insufficientfund notavailable-pos lang-specific-font-name"
              >
                <span class="popup-language-txt">{{
                  'LANG01072' | translate
                }}</span>
              </div>

              <!--select one-->
              <div
                class="popup-header-insufficientfund popup-pos-layout lang-specific-font-name"
              >
                <span class="popup-language-txt">{{
                  'LANG00142' | translate
                }}</span>
              </div>

              <!--live dealer-->
              <div
                class="popup-cntnt-insufficientfund-livedealer lang-specific-font-name"
              >
                <div class="image-pos-top">
                  <img
                    class="bet-icon-gameicon-lc"
                    [appImageSprite]="'livedealer_icon'"
                    [params]="common_icons"
                  />
                </div>
                <span class="popup-pos-layout popup-language-txt">{{
                  'LANG00128' | translate
                }}</span>
              </div>

              <!--real money live dealer-->
              <div
                class="list-item-container_1a"
                (mouseover)="PLSTPopUpOverOrOut(1)"
                (mouseout)="PLSTPopUpOverOrOut(0)"
                (click)="PLSTPopUpClick(false, 1)"
              >
                <div class="image-pos-top">
                  <img
                    class="radio_circle_1"
                    [appImageSprite]="
                      activePlayType == 1 ? 'option_select' : 'option_unselect'
                    "
                    [params]="menu_icons"
                  />
                  <!--<img *ngIf="activePlayType != 1" class="radio_circle_1" [appImageSprite]="('option_unselect')" [params]="menu_icons">
              <img *ngIf="activePlayType == 1" class="radio_circle_1" [appImageSprite]="('option_select')" [params]="menu_icons">-->
                </div>
                <div>
                  <span
                    class="popup-pos-layout lang-specific-font-name popup-language-txt"
                  >
                    {{ 'LANG01071' | translate }}</span
                  >
                </div>
                <div class="arrow_icon_top">
                  <img
                    class="arrow_icon"
                    [appImageSprite]="'arrow_icon'"
                    [params]="common_icons"
                  />
                </div>
              </div>
              <!--live casino-->
              <div
                class="popup-cntnt-insufficientfund-livecasino lang-specific-font-name"
              >
                <div class="image-pos-top">
                  <img
                    class="bet-icon-gameicon-lc"
                    [appImageSprite]="'livecasino'"
                    [params]="common_icons"
                  />
                </div>
                <span class="popup-pos-layout popup-language-txt">{{
                  'LANG00129' | translate
                }}</span>
              </div>

              <!--real money live casino-->
              <div
                class="list-item-container_1b"
                (mouseover)="PLSTPopUpOverOrOut(11)"
                (mouseout)="PLSTPopUpOverOrOut(0)"
                (click)="PLSTPopUpClick(false, 1)"
              >
                <div class="image-pos-top">
                  <img
                    class="radio_circle_1"
                    [appImageSprite]="
                      activePlayType == 11 ? 'option_select' : 'option_unselect'
                    "
                    [params]="menu_icons"
                  />
                  <!--<img *ngIf="activePlayType != 1" class="radio_circle_1" [appImageSprite]="('option_unselect')" [params]="menu_icons">
              <img *ngIf="activePlayType == 1" class="radio_circle_1" [appImageSprite]="('option_select')" [params]="menu_icons">-->
                </div>
                <div>
                  <span
                    class="popup-pos-layout lang-specific-font-name popup-language-txt"
                  >
                    {{ 'LANG01071' | translate }}</span
                  >
                </div>
                <div class="arrow_icon_top">
                  <img
                    class="arrow_icon"
                    [appImageSprite]="'arrow_icon'"
                    [params]="common_icons"
                  />
                </div>
              </div>

              <!--private table-->
              <div
                class="popup-cntnt-insufficientfund-private lang-specific-font-name"
              >
                <div class="image-pos-top">
                  <img
                    class="bet-icon-gameicon-pt"
                    [appImageSprite]="'private'"
                    [params]="common_icons"
                  />
                </div>
                <span class="popup-pos-layout popup-language-txt">{{
                  'LANG00130' | translate
                }}</span>
              </div>

              <!--real money privae-->
              <div
                class="list-item-container_2"
                (mouseover)="PLSTPopUpOverOrOut(2)"
                (mouseout)="PLSTPopUpOverOrOut(0)"
                (click)="PLSTPopUpClick(false, 2)"
              >
                <div class="image-pos-top">
                  <img
                    class="radio_circle_1"
                    [appImageSprite]="
                      activePlayType == 2 ? 'option_select' : 'option_unselect'
                    "
                    [params]="menu_icons"
                  />
                  <!-- <img *ngIf="activePlayType != 2" class="radio_circle_1" [appImageSprite]="('option_unselect')" [params]="menu_icons">
               <img *ngIf="activePlayType == 2" class="radio_circle_1" [appImageSprite]="('option_select')" [params]="menu_icons">-->
                </div>
                <div>
                  <span
                    class="lang-specific-font-name popup-pos-layout popup-language-txt"
                  >
                    {{ 'LANG01071' | translate }}</span
                  >
                </div>
                <div class="arrow_icon_top">
                  <img
                    class="arrow_icon"
                    [appImageSprite]="'arrow_icon'"
                    [params]="common_icons"
                  />
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</div>
